class TSHeader extends HTMLElement {
  constructor() {
    super();
    this.headerHeight = this.getBoundingClientRect().height;
    this.mobileMenu = this.querySelector("#TSHeaderMobile");
    this.predictiveResults = this.querySelector(".ts-header__search-results");
    this.cartBubble = this.querySelector("[data-cart-bubble]");

    this.calcHeader();
    this.initScrollEvents();
    this.initClickEvents();
    this.initCartBubble();

    if (this.predictiveResults) {
      this.initSubmitEvents();
      this.initOnInputEvents();
    }
  }

  calcHeader() {
    const headerObserver = new ResizeObserver(() => {
      const outer = document.querySelector(".ts-header__outer");
      this.headerHeight = this.getBoundingClientRect().height;
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.headerHeight}px`,
      );

      this.classList.toggle(
        "sticky",
        window.scrollY >= outer.getBoundingClientRect().top + window.scrollY,
      );
    });

    headerObserver.observe(this);
  }

  toggleMenu() {
    this.mobileMenu.classList.toggle("open");
    document.documentElement.style.overflow =
      this.mobileMenu.classList.contains("open") ? "hidden" : null;
  }

  initScrollEvents() {
    window.addEventListener("scroll", () => {
      const outer = document.querySelector(".ts-header__outer");
      this.classList.toggle(
        "sticky",
        window.scrollY >= outer.getBoundingClientRect().top + window.scrollY,
      );
    });
  }

  predictiveChange(query) {
    if (query === "") {
      this.predictiveResults.innerHTML = "";
      this.classList.remove("overlay");
      document.documentElement.style.overflow = null;
      return;
    }

    fetch(
      `/search/suggest?q=${encodeURIComponent(query.trim())}&resources[type]=product&section_id=ts-predictive-results`,
    )
      .then((response) => {
        if (!response.ok) {
          this.predictiveResults.innerHTML = "";
          this.classList.remove("overlay");
          document.documentElement.style.overflow = null;
          return;
        }

        return response.text();
      })
      .then((response) => {
        const responseMarkup = new DOMParser().parseFromString(
          response,
          "text/html",
        );
        this.predictiveResults.innerHTML =
          responseMarkup.querySelector(".ts-predictive").innerHTML;
        this.classList.add("overlay");
        document.documentElement.style.overflow = "hidden";
      })
      .catch((error) => {
        console.log("Something going wrong while fetch predictive", error);
      });
  }

  initSubmitEvents() {
    this.addEventListener("submit", (e) => {
      const query = this.querySelector("input[type='search']").value.trim();
      if (!query) {
        e.preventDefault();
      }
    });
  }

  initOnInputEvents() {
    this.querySelector("input[type='search']").addEventListener(
      "input",
      debounce((e) => {
        this.predictiveChange(e.target.value);
      }, 500).bind(this),
    );
  }
  
  initCartBubble() {
    if (!this.cartBubble) return;

    const setBubble = (count) => {
      this.cartBubble.textContent = count;
      this.cartBubble.hidden = count === 0;
    };

    // Debounced: a burst of cart mutations (and the extra theme:cart:* events
    // firing for the same action) collapses into ONE /cart.js request —
    // rapid-fire cart traffic is what trips Shopify's 429 throttling.
    const updateBubble = debounce(() => {
      fetch("/cart.js")
        .then((res) => {
          if (!res.ok) throw new Error(`cart.js ${res.status}`);
          return res.json();
        })
        .then((cart) => setBubble(cart.item_count))
        .catch(() => {}); // throttled/offline — keep the current bubble value
    }, 500);

    window.addEventListener("theme:cart:updated", updateBubble);
    window.addEventListener("theme:cart:productAdded", updateBubble);

    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const result = originalFetch.apply(window, args);
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";
      if (/\/cart\/(add|change|update|clear)/.test(url)) {
        result.then((res) => {
          // Failed mutation (429 throttle etc.): the cart did NOT change.
          // Refetching here is what created the 429 cascade — never react.
          if (!res.ok) return;
          // change/update/clear responses carry the full cart — read the
          // count straight from them, zero extra requests. Only add.js
          // (items-only response) still needs the debounced /cart.js.
          res
            .clone()
            .json()
            .then((data) => {
              if (typeof data.item_count === "number") {
                setBubble(data.item_count);
              } else {
                updateBubble();
              }
            })
            .catch(() => updateBubble());
        });
      }
      return result;
    };
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-trigger")) {
        switch (e.target.dataset.trigger) {
          case "menu-toggle":
            this.toggleMenu();
            break;
          case "close-search":
            this.predictiveResults.innerHTML = "";
            this.classList.remove("overlay");
            document.documentElement.style.overflow = null;
        }
      }
    });
  }
}

customElements.define("ts-header", TSHeader)